export enum DriverGender {
  Unspecified = '',
  Male = 'Male',
  Female = 'Female',
}

export enum MotorDriverSubSection {
  FirstAndLastName = 'First and last name',
  GenderAndDateOfBirth = 'Gender and date of birth',
  YearsDriving = 'Years of experience',
  ClaimsMade = 'Number of claims',
  PayableClaims = 'Number of claims with excess',
}

export type Driver = {
  firstName: string;
  lastName: string;
  gender: DriverGender;
  dob: string;
  yearsDriving: number;
  claimsMade: number;
  payableClaims: number;
};
